<template>
  <div>
    <slot />
  </div>
</template>

<script setup lang="ts">
const attrs = useAttrs()

provide('dropdown', attrs)
</script>
